module.exports = __webpack_public_path__ + "static/media/demo_product.690e9a10.jpg";